export default {
  beforeCreate () {
    const { pending, current } = this.$router.history;
    const { query, params } = pending || current;
    if(query.qd || params.qd) {
      window.localStorage.setItem('source', query.qd || params.qd);
    }
  }
};